export const STARTPAGE = "startpage";
export const STANDARDPAGE = "standardpage";
export const INFORMATIONPAGE = "informationpage";
export const EVENTPAGE = "eventpage";
export const JOBADPAGE = "jobAdpage";
export const NEWSPAGE = "newsItempage";
export const EMPLOYEEPAGE = "employeepage";
export const SEARCHPAGE = "listpage";
export const ERRORPAGE = "errorpage";
export const MAPPAGE = "mappage";
export const COOKIELISTPAGE = "cookieListPage";
export const FORMPAGE = "formPage";
export const ELEMENTPAGE = "elementPage";
export const LISTWITHCATEGORY = "listpageWithCategory";
export const LISTWITHCHILDREN = "listpageWithChildren";
export const REPORTTECHNICALISSUEPAGE = "reportTechnicalIssuePage";
export const FORMWITHCARDPAGE = "formWithCardPage";
export const MAPCITIESPAGE = "mapCitiesPage";
export const MAPCITYPAGE = "mapCityPage";